import image from "../../assets/pagebanner3.jpg";
import img1 from "../../assets/product-detail-full-01.jpg";
import img2 from "../../assets/product-detail-full-02.jpg";
import img3 from "../../assets/product-detail-full-03.jpg";
import img4 from "../../assets/product-detail-full-04.jpg";
import img5 from "../../assets/product-detail-full-05.jpg";

export const DETAIL = [
  {
    img: image,
  },
];

export const FULLIMAGE = [
  {
    id: 1,
    image1: img1,
  },
  {
    id: 2,
    image1: img2,
  },
  {
    id: 3,
    image1: img3,
  },
  {
    id: 4,
    image1: img4,
  },
  {
    id: 5,
    image1: img5,
  },
];
